module.exports = __webpack_public_path__ + "static/media/Mesa-de-trabajo-17.15e1185d.jpg";